import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import UserRoleCard from './UserRoleCard';
import { GetData, PostData } from '../../controls/helpers/requests';
import { getEnvVariable } from '../../../modules/environmentalList';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { IsValidEPRUser } from '../../controls/helpers/plugins/pluginauthenticator';


const UserRoles = (props) => {
    console.log(props);
    const [enabledRoles, setEnabledRoles] = useState([]);
    const [rolesData, setRolesData] = useState([]);
    const [allRoles, setAllRoles] = useState([]);
    const params = useParams();
    const location = useLocation();
    const [eprAccessDesc, setEprAccessDesc] = useState("Email/User not registered for EPR license. Please contact support for further assistance.");
    const [user, setUser] = useState({});

    useEffect(() => {
        loadInitialData();
    }, [location.pathname, params.Id]);

    const loadInitialData = () => {
        let portal = (getEnvVariable('AccessPortal') === 'E' || location.pathname.includes('externalusers')) ? 'E' : 'I';
        let GetUrls = [
            {
                url: getEnvVariable('MasterAdmin') + `/api/SystemRoles/Portal/${portal}`,
                type: 'GET',
            },
            {
                url: getEnvVariable('MasterAdmin') + `/api/UserSystemRoles/Active?userId=${props.dataItem.Id}&portal=${portal}`,
                type: 'GET',
            },
            {
                url: getEnvVariable('MasterAdmin') + `/api/${getEnvVariable('AppModuleKey')}InternalUser/UserById/${props.dataItem.Id}`,
                type: 'GET',
            }
        ];
        Promise.all(GetUrls.map(e => GetData(e.url))).then(data => {
            setDefaultData(data);                     
             console.log(data);
        });
    }

    const setDefaultData = (data) => {        
        const usrRoles = data[1].map(role => role.RoleId);
        const hasEPR =  (Array.isArray(data) && data[0].find(r=> r.Key === 'EPR' && usrRoles.includes(r.Id))) || null;
        
        if(hasEPR){
            IsValidEPRUser(data[2].Email).then(res => {
                const refrolesdata = [...data[0]];
                const eprRole = refrolesdata.find(r => r.Key === 'EPR');
                if (eprRole) {
                    eprRole.ErrorMessage = res.key === 'NOTAUTHORIZED' ? "Not authorized to view EPR data" : (res.status ? res.groups ?? '' : eprAccessDesc) ;
                }
                setRolesData(refrolesdata);
            })
        }else{
            setRolesData(data[0]);
        }
        setAllRoles(data[1]);
        setEnabledRoles(data[1].map(role => role.RoleId.toString())); // Extract RoleId from the response
        setUser(data[2]);           
    }

    const handleToggle = (id) => {
        let eprRole = rolesData.find(r=> r.Key === 'EPR' && r.Id === id);        
        if(eprRole)
            checkEPRAccess(eprRole, id);
        else
            handleToggleWrapper(id);
    };

    const handleToggleWrapper = (id) => {
        let portal = (getEnvVariable('AccessPortal') === 'E' || location.pathname.includes('externalusers')) ? 'E' : 'I';
        let enableRoleIds = enabledRoles.includes(id.toString()) ?
            enabledRoles.filter(roleId => roleId !== id.toString()) :
            [...enabledRoles, id.toString()];
        let isOldRole = allRoles.find(role => role.RoleId === id);
        let payload = {};
        if (isOldRole) {
            isOldRole['Status'] = isOldRole['Status'] === 'A' ? 'I' : 'A';
            payload = isOldRole
        }
        else {
            payload = {
                userId: props.dataItem.Id,
                roleId: id,
            };
        }
        let postURL = getEnvVariable('MasterAdmin') + `/api/UserSystemRoles/SaveOrUpdate/${portal}`;
        PostData(postURL, payload).then(data => {
            if (data){
                setEnabledRoles(enableRoleIds); 
                //Replace current roles with the new one for allroles
                let refrolesdata = rolesData;
                refrolesdata.find(r=> r.Id === id).Status = refrolesdata.find(r=> r.Id === id).Status === 'A' ? 'I' : 'A';
                setRolesData(refrolesdata);
            }                
        });
    }

  

    const checkEPRAccess = (eprRole, id) => {       
        if(eprRole){           
            IsValidEPRUser(user.Email).then(res => {
                let refrolesdata = rolesData;                
                if(!res.status){                    
                    refrolesdata.find(r=> r.Key === 'EPR').ErrorMessage = res.key === 'NOTAUTHORIZED' ? 'Not Authorized to access EPR'  : eprAccessDesc;                    
                    //refrolesdata.find(r=> r.Key === 'EPR').Status = "I";                  
                    setEnabledRoles(enabledRoles.filter(roleId => roleId !== id.toString()));
                    if(eprRole?.Status === 'A'){
                        handleToggleWrapper(id); 
                    }
                    setRolesData(refrolesdata);                    
                }else{
                    //refrolesdata.find(r=> r.Key === 'EPR').Status = eprRole.Status === 'A' ? 'I' : 'A';                  
                    refrolesdata.find(r=> r.Key === 'EPR').ErrorMessage = res?.groups || '';   
                    setRolesData(refrolesdata);                     
                    handleToggleWrapper(id); 
                } 
                
            });
        }
    }

    return (
        <Grid container spacing={1} className='m-2'>
            {rolesData.map(role => (
                <Grid item xs={12} key={role.Id}>
                    <UserRoleCard
                        role={role}
                        isEnabled={role.Id && enabledRoles.includes(role.Id.toString())} // Check if role.Id exists
                        onToggle={handleToggle}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default UserRoles;